module.exports = __webpack_public_path__ + "media/images/demo_tests/balloons-23578091a777827e9b7804c087072a95.png";